/**
 * 定数定義
 * @module KomaeConfig
 */

/**
 * 対象のココシルのサイト識別ラベル
 * @static
 * @const {string}
 * @default "komae-iryouaigotiiki-map"
 */
const KOKOSIL_SITE_LABEL="komae-iryoukaigotiiki-map";

/**
 * 対象のココシルサイトのトップURL
 * @static
 * @const {string}
 * @default "https://komae-iryoukaigotiiki-map.kokosil.net"
 */
const KOKOSIL_TOP = "https://komae-iryoukaigotiiki-map.kokosil.net";

/**
 * 対象のココシルAPIのトップURL
 * @static
 * @const {string}
 * @default "https://komae-iryoukaigotiiki-map.kokosil.net/api/v3"
 */
const KOKOSIL_API = KOKOSIL_TOP + "/api/v3";

/**
 * 一度の検索で取得するスポット数
 * @static
 * @const {integer}
 * @default 48
 */
const KOKOSIL_SPOTS_LIMIT = 48;

/**
 * 場所や地図を別タブで開くときの target
 * @static
 * @const {string}
 * @default "komae-iryoukaigotiiki-map"
 */
const KOKOSIL_TAB_TARGET = "komae-iryoukaigotiiki-map";

export {
  KOKOSIL_SITE_LABEL,
  KOKOSIL_TOP,
  KOKOSIL_API,
  KOKOSIL_SPOTS_LIMIT,
  KOKOSIL_TAB_TARGET
};
